import { Link } from 'react-router-dom';
import { getHotActresses } from '@/mocks/actresses';
import ActressCard from '@/components/base/ActressCard';

export default function LatestUpdates() {
  const hotActresses = getHotActresses();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-medium mb-3">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-fire-fill text-[10px]"></i>
              </div>
              人气飙升
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
              热门女优
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              当下搜索量和关注度最高的日本女优
            </p>
          </div>
          <Link
            to="/category/popular-ranking"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {hotActresses.map((actress) => (
            <ActressCard key={actress.id} actress={actress} />
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/popular-ranking"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部热门女优
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}